module.exports = __webpack_public_path__ + "img/icon_white.1c9bf3fc.png";